'use strict';

import React, { Component } from 'react'

import DatePicker from '@/Form/V2/DatePicker'

import getErrorsFromResponse from '@/Form/Functions/getErrorsFromResponse'
import getFormStatus         from '@/Form/Functions/getFormStatus'

import { handleChange } from '@/Form/Functions/eventsHandling'

import FormElement from '@/Form/toolkit/FormElement'

import Loader from '@Pure/Loader'
import Modal  from '@Modal/Modal'

const { app, qwest } = window;

export default class UserDisabledDateModal extends Component
{
	state =
	{
		open: false,
		form_data: { },
		status_messages: { }
	};

	handleChange = handleChange.bind(this);

	handleDateChange = ({ e, value, name }) =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState(
		{
			form_data:
			{
				...state.form_data,

				[name]: value
			},

			status_messages: { }
		});
	}

	componentDidMount ()
	{
		const component = this, props = this.props, state = this.state;

		app.push(
		{
			event: 'open__UserDisabledDateModal',
			cb: component.open
		});
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props, state = this.state;

		app.delete(
		{
			event: 'open__UserDisabledDateModal',
			cb: component.open
		});
	}

	handleClose = (e, force) =>
	{
		const component = this, props = this.props, state = this.state;

		if (state.loading === true && !force)
		{
			return e.stopPropagation();
		}

		component.setState(
		{
			open: false,
			loading: false
		});
	}

	open = (data) =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState(
		{
			open : true,
			data: data,
			form_data: { disabled_date: data.disabled_date || '' }
		});
	}

	validate = (e) =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState(
		{
			loading: true
		});

		qwest.post('/user/update-disabled-date',
		{
			id: state.data.id,
			disabled_date: state.form_data.disabled_date
		})
		.then(function (xhr, response)
		{
			app.emit('changedUserDisabledDate', component.state.data.id);

			component.handleClose(e, true);
		})
		.catch(function (error, xhr, response)
		{
			console.error(response?.error || response?.raw || error);
		
			component.setState(
			{
				...getErrorsFromResponse(
				{
					response: response
				})
			});
		});
	}

	render ()
	{
		const props = this.props, component = this, state = this.state;

		const loader = state.loading === true ?
		(
			<Loader className="c-loader" bemit={ ['primary', 'bg-white'] } />
		)
		: undefined;

		let output =
		(
			<Modal open={ state.open } onClose={ component.handleClose }
				title="Date de désactivation" hide_close={ true }>

				<DatePicker name="disabled_date" label="Date de désactivation"
					onChange={ component.handleDateChange }
					value={ state.form_data.disabled_date }
					status={ state.status_messages }
					bemit={ ['fixed-width'] }
				/>

				{ getFormStatus(state) }

				<div className="c-dialog__buttons u-flex u-flex-wrap u-content-between">

					<div className="u-full-width">
						<button className="c-btn c-btn--green
							c-dialog__danger u-margin-right-15"
							onClick={ component.validate }>
							Valider
						</button>

						<button className="c-btn c-dialog__cancel"
							onClick={ component.handleClose }>
							Fermer
						</button>
					</div>

				</div>

				{ loader }

			</Modal>
		);

		return output;
	}
}
